import { Box, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { STATUS_COLOR } from '../constants/constants';
import { Status } from '../types/Status';

// カードの横幅
const listCardWidth = 353;

type Props = {
  onClick: () => void;
  status?: Status | null;
  label: string;
};

const Card = ({ onClick, status, label }: Props) => {
  return (
    <Grid item xs={12} md={6} sx={{ width: `${listCardWidth}px`, justifyContent: 'center', display: 'flex' }}>
      <button
        onClick={onClick}
        type="button"
        style={{
          width: `${listCardWidth}px`,
          padding: '18px 0',
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          fontSize: '18px',
          lineHeight: '1.5',
          fontWeight: 'bold'
        }}
      >
        {label}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            position: 'absolute',
            right: '4px',
            top: '50%',
            transform: 'translateY(-50%)'
          }}
        >
          {status && (
            <Box sx={{ fontSize: '10px', lineHeight: '1.5', fontWeight: 'bold' }}>
              <span style={STATUS_COLOR[status]}>{status}</span>
            </Box>
          )}
          <ArrowForwardIosIcon />
        </Box>
      </button>
    </Grid>
  );
};
export default Card;
